// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import $ from "jquery";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import { errorMessage, successMessage } from "../utils/tostify";

// import { getallmembershiptypes, editMember, savemembershippayment } from "../store/slices/userSlice";

// import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap';
// import Navbar from "../components/Navbar";
// import Sidebar from "../components/Sidebar";

// function RenewMembershipAndPayment() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { hidesidebar } = location.state || {};

//   const [membershipTypes, setMembershipTypes] = useState([]);
//   const [loadingMembershipTypes, setLoadingMembershipTypes] = useState(true);

//   const [showPaymentSection, setShowPaymentSection] = useState(false);
//   const [selectedMembershipDetails, setSelectedMembershipDetails] = useState(null);
//   const [loadingPayPal, setLoadingPayPal] = useState(true);
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const [subscriptionID, setSubscriptionID] = useState(null);
//   const [countdown, setCountdown] = useState(5);
//   const [paymentMode, setPaymentMode] = useState("subscription"); // Default to subscription

//   // New state to track if membership expired more than 30 days ago
//   const [isExpiredMoreThan30Days, setIsExpiredMoreThan30Days] = useState(false);
//   // State for adjusted one-time payment amount
//   const [adjustedOneTimeAmount, setAdjustedOneTimeAmount] = useState(0);

//   const { error, status: reduxStatus } = useSelector((state) => state.user);
//   const userId = localStorage.getItem('id');

//   const paypalRenderedRef = useRef(false);
//   const scriptLoadingRef = useRef(false);
//   const paypalContainerRef = useRef(null);

//   const unwrapResult = useCallback((result) => {
//     if (result.payload) {
//       return result.payload;
//     } else if (result.error) {
//       throw result.error;
//     }
//     return result;
//   }, []);

//   const startCountdownAndRedirect = useCallback(() => {
//     try {
//       let count = 5;
//       setCountdown(count);
//       const timer = setInterval(() => {
//         count--;
//         setCountdown(count);
//         if (count === 0) {
//           clearInterval(timer);
//           navigate('/dashboard');
//         }
//       }, 1000);
//     } catch (error) {
//       console.error("Error during countdown and redirect:", error);
//       // Optionally redirect immediately or show a user-friendly message
//       navigate('/dashboard');
//     }
//   }, [navigate]);
  
//   const cleanupPayPalSDK = useCallback(() => {
//     try {
//       console.log("Cleanup: Starting PayPal SDK cleanup.");
      
//       const scriptId = 'paypal-sdk-script';
//       const existingScript = document.getElementById(scriptId);
//       if (existingScript) {
//         existingScript.remove();
//         console.log("Cleanup: Removed existing PayPal SDK script.");
//       }
  
//       if (window.paypal) {
//         console.log("Cleanup: Found window.paypal, attempting to clear its properties.");
//         try {
//           window.paypal = undefined;
//           delete window.paypal;
//           console.log("Cleanup: window.paypal nullified/deleted.");
//         } catch (e) {
//           console.warn("Cleanup: Could not delete window.paypal:", e);
//         }
//       }
  
//       if (paypalContainerRef.current) {
//         paypalContainerRef.current.innerHTML = '';
//         console.log("Cleanup: Cleared PayPal button container.");
//       }
  
//       paypalRenderedRef.current = false;
//       scriptLoadingRef.current = false;
//       console.log("Cleanup: PayPal SDK cleanup complete. Render flags reset.");
      
//     } catch (error) {
//       console.error("Cleanup: An error occurred during PayPal SDK cleanup:", error);
//     }
//   }, []);
  

//   useEffect(() => {
//     try {
//       $(".preloader").fadeOut();
//     } catch (err) {
//       console.warn("Failed to hide preloader:", err);
//     }
//   }, []);
  
//   useEffect(() => {
//     try {
//       if (reduxStatus === "failed" && error) {
//         errorMessage(error);
//       }
//     } catch (err) {
//       console.error("Error handling Redux status failure:", err);
//     }
//   }, [error, reduxStatus]);
  

//   useEffect(() => {
//     const fetchMembershipTypes = async () => {
//       setLoadingMembershipTypes(true);
//       try {
//         const response = await getallmembershiptypes();
//         if (response?.status === 200 && response.data) {
//           setMembershipTypes(
//             Array.isArray(response.data)
//               ? response.data.filter((type) => type.status === "1")
//               : []
//           );
//         } else {
//           errorMessage("Error fetching membership types!");
//         }
//       } catch (error) {
//         console.error("Error fetching membership types:", error);
//         errorMessage("Error fetching membership types!");
//       } finally {
//         setLoadingMembershipTypes(false);
//       }
//     };
//     fetchMembershipTypes();
//   }, []);

//   // Effect to determine if membership expired more than 30 days ago
//   useEffect(() => {
//     try {
//       const currentValidUpto = localStorage.getItem('validupto');
//       if (currentValidUpto) {
//         const parts = currentValidUpto.split('-');
//         if (parts.length === 3) {
//           const validUptoDate = new Date(
//             parseInt(parts[0]),
//             parseInt(parts[1]) - 1,
//             parseInt(parts[2])
//           );
//           const today = new Date();
  
//           // Set both dates to midnight for accurate day comparison
//           validUptoDate.setHours(0, 0, 0, 0);
//           today.setHours(0, 0, 0, 0);
  
//           const diffTime = today.getTime() - validUptoDate.getTime();
//           const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
//           if (diffDays > 30) {
//             setIsExpiredMoreThan30Days(true);
//             setPaymentMode("onetime");
//           } else {
//             setIsExpiredMoreThan30Days(false);
//           }
//         } else {
//           console.warn("Invalid date format for 'validupto':", currentValidUpto);
//           setIsExpiredMoreThan30Days(false);
//         }
//       } else {
//         setIsExpiredMoreThan30Days(false);
//       }
//     } catch (error) {
//       console.error("Error parsing 'validupto' from localStorage:", error);
//       setIsExpiredMoreThan30Days(false);
//     }
//   }, []);
  
//   const formik = useFormik({
//     initialValues: {
//       membershiptype: "",
//       validUpto: "",
//       amount: 0,
//     },
//     validationSchema: Yup.object({
//       membershiptype: Yup.string().required("Membership type is required"),
//     }),
//     onSubmit: (values) => {
//       console.log("Renew Membership Form Submitted", values);
  
//       const selectedType = membershipTypes.find(
//         (type) => type.id === values.membershiptype
//       );
  
//       if (!selectedType || parseFloat(selectedType.amount) <= 0) {
//         errorMessage("Selected membership type has no valid amount.");
//         return;
//       }
  
//       let finalAmount = parseFloat(selectedType.amount);
  
//       if (isExpiredMoreThan30Days && paymentMode === "onetime") {
//         const currentValidUpto = localStorage.getItem('validupto');
//         if (currentValidUpto) {
//           const parts = currentValidUpto.split('-');
//           if (parts.length === 3) {
//             const validUptoDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
//             const today = new Date();
  
//             const diffMonths =
//               (today.getFullYear() - validUptoDate.getFullYear()) * 12 +
//               (today.getMonth() - validUptoDate.getMonth());
  
//             const durationInMonths = parseInt(selectedType.duration) / 30;
//             const monthlyRate =
//               durationInMonths > 0
//                 ? parseFloat(selectedType.amount) / durationInMonths
//                 : parseFloat(selectedType.amount);
  
//             const monthsExpired = Math.max(0, diffMonths);
//             finalAmount = monthsExpired * monthlyRate;
  
//             setAdjustedOneTimeAmount(finalAmount);
//             console.log(
//               `Membership expired ${monthsExpired} months ago. Monthly rate: ₹${monthlyRate.toFixed(
//                 2
//               )}. Adjusted one-time amount: ₹${finalAmount.toFixed(2)}`
//             );
//           } else {
//             console.warn("Invalid 'validupto' format:", currentValidUpto);
//           }
//         }
//       } else {
//         setAdjustedOneTimeAmount(0);
//       }
  
//       setSelectedMembershipDetails({
//         membershipTypeId: selectedType.id,
//         membershipTypeName: selectedType.name,
//         membershipTypeAmount: finalAmount,
//         newValidUpto: values.validUpto,
//         paypalPlanId: selectedType.paypal_plan_id,
//       });
  
//       setShowPaymentSection(true);
//       setPaymentStatus(null);
//     },
//   });
  

//   // const handleMembershipTypeChange = (e) => {
//   //   const selectedMembershipId = e.target.value;
//   //   const selectedType = membershipTypes.find(
//   //     (type) => type.id === selectedMembershipId
//   //   );

//   //   formik.handleChange(e);

//   //   if (selectedType) {
//   //     const currentValidUpto = localStorage.getItem('validupto');
//   //     let newValidityCalculationDate = new Date(); // Start calculation from today's date

//   //     if (currentValidUpto) {
//   //       const parts = currentValidUpto.split('-');
//   //       if (parts.length === 3) {
//   //         const storedValidUptoDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
//   //         const today = new Date();
//   //         today.setHours(0, 0, 0, 0); // Normalize today for comparison

//   //         // If current validity is in the future, extend from that date.
//   //         // Otherwise (expired or today), extend from today.
//   //         if (storedValidUptoDate.getTime() > today.getTime()) {
//   //           newValidityCalculationDate = storedValidUptoDate;
//   //         }
//   //         // If storedValidUptoDate is <= today, then newValidityCalculationDate remains today.
//   //       } else {
//   //         console.warn("Invalid 'validupto' date format in localStorage. Using today's date for new validity calculation.");
//   //       }
//   //     } else {
//   //       console.warn("'validupto' not found in localStorage. Using today's date for new validity calculation.");
//   //     }

//   //     const duration = parseInt(selectedType.duration);
//   //     newValidityCalculationDate.setDate(newValidityCalculationDate.getDate() + duration);

//   //     formik.setFieldValue("validUpto", newValidityCalculationDate.toISOString().split("T")[0]);
//   //     formik.setFieldValue("amount", parseFloat(selectedType.amount)); // Keep base amount for Formik values
//   //   } else {
//   //     formik.setFieldValue("validUpto", "");
//   //     formik.setFieldValue("amount", 0);
//   //   }
//   // };


//   const handleMembershipTypeChange = (e) => {
//     const selectedMembershipId = e.target.value;
//     const selectedType = membershipTypes.find(
//       (type) => type.id === selectedMembershipId
//     );
  
//     formik.handleChange(e);
  
//     if (selectedType) {
//       const currentValidUpto = localStorage.getItem('validupto');
//       let newValidityCalculationDate = new Date(); // Start calculation from today's date
  
//       if (currentValidUpto) {
//         const parts = currentValidUpto.split('-');
//         if (parts.length === 3) {
//           const storedValidUptoDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
//           const today = new Date();
//           today.setHours(0, 0, 0, 0); // Normalize today for comparison
  
//           if (storedValidUptoDate.getTime() > today.getTime()) {
//             newValidityCalculationDate = storedValidUptoDate;
//           }
//         } else {
//           console.warn("Invalid 'validupto' date format in localStorage. Using today's date for new validity calculation.");
//         }
//       } else {
//         console.warn("'validupto' not found in localStorage. Using today's date for new validity calculation.");
//       }
  
//       const duration = parseInt(selectedType.duration);
//       newValidityCalculationDate.setDate(newValidityCalculationDate.getDate() + duration);
  
//       const formattedValidUpto = `${String(newValidityCalculationDate.getMonth() + 1).padStart(2, '0')}-${String(newValidityCalculationDate.getDate()).padStart(2, '0')}-${newValidityCalculationDate.getFullYear()}`;
//       formik.setFieldValue("validUpto", formattedValidUpto);
//       formik.setFieldValue("amount", parseFloat(selectedType.amount));
//     } else {
//       formik.setFieldValue("validUpto", "");
//       formik.setFieldValue("amount", 0);
//     }
//   };

  
//   useEffect(() => {
//     if (!showPaymentSection || !selectedMembershipDetails || !userId) {
//       return;
//     }

//     const { membershipTypeId, membershipTypeName, membershipTypeAmount, newValidUpto, paypalPlanId } = selectedMembershipDetails;

//     if (paypalRenderedRef.current || scriptLoadingRef.current) {
//       console.log("PayPal buttons already rendered or script loading in progress, skipping re-initialization.");
//       setLoadingPayPal(false);
//       return;
//     }

//     scriptLoadingRef.current = true;

//     const loadAndRenderPayPalButtons = async () => {
//       setLoadingPayPal(true);
//       try {
//         cleanupPayPalSDK(); // Perform immediate cleanup

//         // Introduce a small delay to allow browser to clear up resources
//         await new Promise(resolve => setTimeout(resolve, 50)); // Wait for 50ms

//         const container = paypalContainerRef.current;
//         if (!container) {
//           console.error("PayPal button container not found in DOM. Cannot proceed.");
//           errorMessage("Payment container not found. Please refresh the page.");
//           setPaymentStatus('fail');
//           setLoadingPayPal(false);
//           scriptLoadingRef.current = false;
//           return;
//         }

//         const scriptId = 'paypal-sdk-script';
//         const script = document.createElement('script');
//         script.id = scriptId;

//         if (paymentMode === "subscription") {
//           script.src = `https://www.paypal.com/sdk/js?client-id=AYB2yrW-VqMF7hAxqkXp4KZP-wLFomi24wBCLVQB3hna7V2mCdqZz4e4V3muCnlVw_6VcD4yhXQY0Rp8&vault=true&intent=subscription`; // Replace YOUR_PAYPAL_CLIENT_ID
//         } else {
//           script.src = `https://www.paypal.com/sdk/js?client-id=AYB2yrW-VqMF7hAxqkXp4KZP-wLFomi24wBCLVQB3hna7V2mCdqZz4e4V3muCnlVw_6VcD4yhXQY0Rp8&currency=USD`; // Replace YOUR_PAYPAL_CLIENT_ID
//         }
        
//         script.setAttribute('data-sdk-integration-source', 'button-factory');
//         script.async = true;
//         document.body.appendChild(script);
//         console.log("PayPal SDK script appended to body.");

//         await new Promise((resolve, reject) => {
//           script.onload = () => {
//             console.log("PayPal SDK script loaded. Starting check for window.paypal.Buttons...");
//             const checkReady = setInterval(() => {
//               if (window.paypal && typeof window.paypal.Buttons === 'function') {
//                 clearInterval(checkReady);
//                 console.log("PayPal SDK loaded and ready (Buttons function found).");
//                 resolve();
//               }
//             }, 100);
//           };
//           script.onerror = (error) => {
//             console.error("Failed to load PayPal SDK script:", error);
//             reject(new Error("PayPal SDK script failed to load."));
//           };
//         });

//         console.log("Attempting to render PayPal buttons...");

//         if (paymentMode === "subscription") {
//           window.paypal.Buttons({
//             style: {
//               shape: 'pill',
//               color: 'gold',
//               layout: 'vertical',
//               label: 'subscribe',
//             },
//             createSubscription: function (data, actions) {
//               if (!paypalPlanId) {
//                 errorMessage("PayPal Plan ID is missing for this membership type.");
//                 throw new Error("PayPal Plan ID missing.");
//               }
//               console.log("Creating subscription with plan_id:", paypalPlanId);
//               return actions.subscription.create({
//                 plan_id: paypalPlanId,
//               });
//             },
//             onApprove: async function (data, actions) {
//               if (data.subscriptionID) {
//                 setSubscriptionID(data.subscriptionID);
//                 setPaymentStatus('success');
//                 successMessage("Payment successful! Updating membership status...");
//                 console.log("PayPal subscription approved. ID:", data.subscriptionID);

//                 try {
//                   const savePaymentAction = await dispatch(savemembershippayment({
//                     member: userId,
//                     orderid: data.subscriptionID,
//                     paymentstatus: 'COMPLETED',
//                     amount: membershipTypeAmount, // Use membershipTypeAmount which is the original amount for subscription
//                     paymentmode: 'Paypal Subscription',
//                     subscription: membershipTypeId,
//                     date: new Date().toISOString().split('T')[0],
//                     status: 1
//                   }));
//                   // unwrapResult(savePaymentAction); // Removed unwrapResult for now as per original code comment and potential thunk direct usage
//                   console.log("Payment record saved successfully in backend.");

//                   const updateMemberAction = await dispatch(editMember({
//                     id: userId,
//                     validupto: newValidUpto,
//                     status: "1"
//                   }));
//                   // unwrapResult(updateMemberAction); // Removed unwrapResult for now
//                   localStorage.setItem('validupto', newValidUpto);
//                   console.log("Member validupto updated successfully after payment.");
//                   successMessage("Membership successfully renewed!");
//                   startCountdownAndRedirect();
//                 } catch (backendError) {
//                   console.error("Error during backend update after PayPal approval:", backendError);
//                   errorMessage("Payment successful, but failed to update your membership or save payment record in backend. Please contact support.");
//                   setPaymentStatus('fail');
//                 }
//               } else {
//                 setPaymentStatus('fail');
//                 errorMessage("PayPal subscription ID not returned.");
//                 console.error("PayPal subscription ID missing from onApprove data.");
//               }
//             },
//             onCancel: function () {
//               setPaymentStatus('cancel');
//               errorMessage("PayPal subscription cancelled by user.");
//               console.log("PayPal subscription cancelled.");
//             },
//             onError: function (err) {
//               console.error('PayPal Error (Subscription):', err);
//               setPaymentStatus('fail');
//               errorMessage("An error occurred during PayPal subscription. Please try again.");
//             }
//           }).render(container);
//         } else {
//           window.paypal.Buttons({
//             style: {
//               shape: 'pill',
//               color: 'blue',
//               layout: 'vertical',
//               label: 'pay',
//             },
//             createOrder: function (data, actions) {
//               return actions.order.create({
//                 purchase_units: [{
//                   amount: {
//                     value: membershipTypeAmount.toFixed(2), // Use membershipTypeAmount which can be adjusted
//                     currency_code: "USD"
//                   },
//                   description: `One-time Membership Payment: ${membershipTypeName}`,
//                 }]
//               });
//             },
//             onApprove: async function (data, actions) {
//               try {
//                 const order = await actions.order.capture();
//                 console.log("One-time payment order captured", order);
//                 setSubscriptionID(order.id);
//                 setPaymentStatus('success');
//                 successMessage("Payment successful! Updating membership status...");

//                 try {
//                   const savePaymentAction = await (savemembershippayment({
//                     member: userId,
//                     orderid: order.id,
//                     paymentstatus: 'COMPLETED',
//                     amount: membershipTypeAmount, // Use membershipTypeAmount which can be adjusted
//                     paymentmode: 'Paypal One-Time',
//                     subscription: membershipTypeId,
//                     date: new Date().toISOString().split('T')[0],
//                     status: 1
//                   }));
//                   // unwrapResult(savePaymentAction); // Removed unwrapResult for now
//                   console.log("Payment record saved successfully in backend.");

//                   const updateMemberAction = await (editMember({
//                     id: userId,
//                     validupto: newValidUpto,
//                     status: "1"
//                   }));
//                   // unwrapResult(updateMemberAction); // Removed unwrapResult for now
//                   localStorage.setItem('validupto', newValidUpto);
//                   console.log("Member validupto updated successfully after payment.");
//                   successMessage("Membership successfully renewed!");
//                   startCountdownAndRedirect();
//                 } catch (backendError) {
//                   console.error("Error during backend update after PayPal approval:", backendError);
//                   errorMessage("Payment successful, but failed to update your membership or save payment record in backend. Please contact support.");
//                   setPaymentStatus('fail');
//                 }
//               } catch (captureError) {
//                 console.error("PayPal Capture Error (One-Time):", captureError);
//                 setPaymentStatus('fail');
//                 errorMessage("Failed to capture PayPal payment. Please try again.");
//               }
//             },
//             onCancel: function (data) {
//               setPaymentStatus('cancel');
//               errorMessage("PayPal payment cancelled by user.");
//               console.log("PayPal one-time payment cancelled.", data);
//             },
//             onError: function (err) {
//               console.error('PayPal Error (One-Time):', err);
//               setPaymentStatus('fail');
//               errorMessage("An error occurred during PayPal payment. Please try again.");
//             }
//           }).render(container);
//         }

//         console.log("PayPal buttons rendered successfully.");
//         paypalRenderedRef.current = true;
//       } catch (e) {
//         console.error("Error during PayPal button initialization:", e);
//         setPaymentStatus('fail');
//         errorMessage("Failed to load PayPal payment options.");
//         scriptLoadingRef.current = false;
//       } finally {
//         setLoadingPayPal(false);
//       }
//     };

//     loadAndRenderPayPalButtons();

//     return () => {
//       console.log("Running cleanup via useEffect return function.");
//       cleanupPayPalSDK();
//     };
//   }, [
//     showPaymentSection,
//     selectedMembershipDetails,
//     userId,
//     dispatch,
//     unwrapResult,
//     startCountdownAndRedirect,
//     cleanupPayPalSDK,
//     paymentMode,
//     isExpiredMoreThan30Days
//   ]);

//   return (
//     <div>
//       <Navbar />
//       {!hidesidebar && <Sidebar />}
//       {(loadingMembershipTypes || (showPaymentSection && loadingPayPal)) && (
//         <div className="preloader" style={{ display: "block" }}>
//           <div className="lds-ripple">
//             <div className="lds-pos"></div>
//             <div className="lds-pos"></div>
//           </div>
//         </div>
//       )}

//       <div id="main-wrapper" className="flex flex-col min-h-screen">
//         <div className="page-wrapper flex-grow d-block">
//           <div className="body-wrapper">
//             <Container fluid className="h-full">
//               <div className="folio-container"></div>
//               <Row className="justify-content-center items-center h-full min-h-[calc(100vh-60px)]">
//                 <Col lg={6} md={8}>
//                   <Card className="w-100 rounded-xl shadow-lg">
//                     <Card.Header style={{ background: "#f06969" }} className="rounded-t-xl">
//                       <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
//                         <h4 className="card-title fw-semibold text-white text-2xl">
//                           {showPaymentSection ? "Membership Payment" : "Renew Membership"}
//                         </h4>
//                       </div>
//                     </Card.Header>
//                     <Card.Body className="p-6">
//                       {!showPaymentSection ? (
//                         <Form onSubmit={formik.handleSubmit}>
//                           <Row>
//                             <Col md={12}>
//                               <Form.Group className="mb-3" controlId="membershiptype">
//                                 <Form.Label>Select New Membership Type</Form.Label>
//                                 <Form.Select
//                                   {...formik.getFieldProps("membershiptype")}
//                                   onChange={handleMembershipTypeChange}
//                                   isInvalid={formik.touched.membershiptype && !!formik.errors.membershiptype}
//                                 >
//                                   <option value="">Select Membership Type</option>
//                                   {membershipTypes.map((type) => (
//                                     <option key={type.id} value={type.id}>
//                                       {type.name} - {type.duration} days - ${type.amount}
//                                     </option>
//                                   ))}
//                                 </Form.Select>
//                                 <Form.Control.Feedback type="invalid">
//                                   {formik.errors.membershiptype}
//                                 </Form.Control.Feedback>
//                               </Form.Group>
//                             </Col>

//                             <Form.Group className="mb-3">
//                               <Form.Label>Select Payment Mode</Form.Label>
//                               <div>
//                                 {(!isExpiredMoreThan30Days) && (formik.values.membershiptype === "2") && ( // Conditionally render subscription option
//                                   <Form.Check
//                                     inline
//                                     label="Subscription"
//                                     name="paymentMode"
//                                     type="radio"
//                                     id="subscription"
//                                     checked={paymentMode === "subscription"}
//                                     onChange={() => {
//                                       setPaymentMode("subscription");
//                                       paypalRenderedRef.current = false;
//                                       scriptLoadingRef.current = false;
//                                     }}
//                                   />
//                                 )}
//                                 <Form.Check
//                                   inline
//                                   label="One-Time"
//                                   name="paymentMode"
//                                   type="radio"
//                                   id="one-time"
//                                   checked={paymentMode === "onetime"}
//                                   onChange={() => {
//                                     setPaymentMode("onetime");
//                                     paypalRenderedRef.current = false;
//                                     scriptLoadingRef.current = false;
//                                   }}
//                                   disabled={isExpiredMoreThan30Days} // Disable if subscription is forced
//                                 />
//                               </div>
//                                {isExpiredMoreThan30Days && (
//                                 <p className="text-sm text-red-500 mt-2">
//                                   Your membership expired more than 30 days ago. Only one-time payment is available.
//                                 </p>
//                               )}
//                             </Form.Group>

//                             {formik.values.validUpto && (
//                               <Col md={12}>
//                                 <Form.Group className="mb-3" controlId="validUpto">
//                                   <Form.Label>New Membership Valid Until</Form.Label>
//                                   <Form.Control
//                                     type="text"
//                                     value={formik.values.validUpto}
//                                     readOnly
//                                   />
//                                 </Form.Group>
//                               </Col>
//                             )}
//                           </Row>

//                           <div className="text-center mt-3">
//                             <Button variant="dark" type="submit" className="w-50" >
//                               Proceed to Payment
//                             </Button>
//                           </div>
//                         </Form>
//                       ) : (
//                         <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-b-xl font-inter">
//                           <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md text-center">
//                             <h2 className="text-3xl font-bold text-gray-800 mb-6">
//                               Complete Your {paymentMode === "subscription" ? "Subscription" : "Payment"}</h2>
//                             <p className="text-lg text-gray-600 mb-4">
//                               Selected Membership: <strong>{selectedMembershipDetails?.membershipTypeName || 'N/A'}</strong> (Valid until: <strong>{selectedMembershipDetails?.newValidUpto || 'N/A'}</strong>)
//                               <br />Amount: <strong>${selectedMembershipDetails?.membershipTypeAmount ? parseFloat(selectedMembershipDetails.membershipTypeAmount).toFixed(2) : '0.00'}</strong>
//                               {isExpiredMoreThan30Days && paymentMode === "onetime" && (
//                                 <span className="block text-sm text-gray-500 mt-1"> (Adjusted for past due period)</span>
//                               )}
//                             </p>

//                             {loadingPayPal && (
//                               <div className="text-blue-600 text-lg mb-4">Loading PayPal buttons...</div>
//                             )}

//                             <div id="paypal-button-container" ref={paypalContainerRef} className="mb-6"></div>

//                             {paymentStatus === 'success' && (
//                               <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-md relative mb-4">
//                                 <strong className="font-bold">✅ Payment Successful!</strong>
//                                 <span className="block sm:inline"> Your membership is now active.</span>
//                                 {subscriptionID && (
//                                   <p className="text-sm mt-2">Transaction ID: <code className="font-mono bg-green-200 p-1 rounded">{subscriptionID}</code></p>
//                                 )}
//                                 <p className="mt-3">Redirecting to dashboard in {countdown} seconds...</p>
//                               </div>
//                             )}

//                             {paymentStatus === 'fail' && (
//                               <div className="bg-red-100 text-red-700 p-4 rounded-lg font-semibold flex items-center justify-center gap-2">
//                                 <span className="text-2xl">❌</span> Payment Failed. Please try again or contact support.
//                               </div>
//                             )}

//                             {paymentStatus === 'cancel' && (
//                               <div className="bg-orange-100 text-orange-700 p-4 rounded-lg font-semibold flex items-center justify-center gap-2">
//                                 <span className="text-2xl">⚠️</span> {paymentMode === "subscription" ? "Subscription" : "Payment"} was cancelled by the user.
//                               </div>
//                             )}
//                             <div className="text-center mt-4">
//                               <Button variant="secondary" onClick={() => setShowPaymentSection(false)}>
//                                 Back to Membership Selection
//                               </Button>
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                     </Card.Body>
//                   </Card>
//                 </Col>
//               </Row>
//             </Container>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default RenewMembershipAndPayment;


import React, { useState, useEffect, useRef, useCallback } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { errorMessage, successMessage } from "../utils/tostify";

import { getallmembershiptypes, editMember, savemembershippayment } from "../store/slices/userSlice";

import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap';
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function RenewMembershipAndPayment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { hidesidebar } = location.state || {};

  const [membershipTypes, setMembershipTypes] = useState([]);
  const [loadingMembershipTypes, setLoadingMembershipTypes] = useState(true);

  const [showPaymentSection, setShowPaymentSection] = useState(false);
  const [selectedMembershipDetails, setSelectedMembershipDetails] = useState(null);
  const [loadingPayPal, setLoadingPayPal] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [subscriptionID, setSubscriptionID] = useState(null);
  const [countdown, setCountdown] = useState(5);
  const [paymentMode, setPaymentMode] = useState("subscription"); // Default to subscription

  // New state to track if membership expired more than 30 days ago
  const [isExpiredMoreThan30Days, setIsExpiredMoreThan30Days] = useState(false);
  // State for adjusted one-time payment amount
  const [adjustedOneTimeAmount, setAdjustedOneTimeAmount] = useState(0);

  const { error, status: reduxStatus } = useSelector((state) => state.user);
  const userId = localStorage.getItem('id');

  const paypalRenderedRef = useRef(false);
  const scriptLoadingRef = useRef(false);
  const paypalContainerRef = useRef(null); // Ref for the generic PayPal button container

  // PayPal's specific subscription button container ID
  const PAYPAL_SUBSCRIPTION_CONTAINER_ID = 'paypal-button-container-P-8EG07744WM7769432NBOKQKQ';


  const unwrapResult = useCallback((result) => {
    if (result.payload) {
      return result.payload;
    } else if (result.error) {
      throw result.error;
    }
    return result;
  }, []);

  const startCountdownAndRedirect = useCallback(() => {
    try {
      let count = 5;
      setCountdown(count);
      const timer = setInterval(() => {
        count--;
        setCountdown(count);
        if (count === 0) {
          clearInterval(timer);
          navigate('/dashboard');
        }
      }, 1000);
    } catch (error) {
      console.error("Error during countdown and redirect:", error);
      // Optionally redirect immediately or show a user-friendly message
      navigate('/dashboard');
    }
  }, [navigate]);
  
  const cleanupPayPalSDK = useCallback(() => {
    try {
      console.log("Cleanup: Starting PayPal SDK cleanup.");
      
      const scriptId = 'paypal-sdk-script';
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
        console.log("Cleanup: Removed existing PayPal SDK script.");
      }
  
      if (window.paypal) {
        console.log("Cleanup: Found window.paypal, attempting to clear its properties.");
        try {
          // Attempt to nullify window.paypal to prevent re-rendering issues
          window.paypal = undefined;
          delete window.paypal;
          console.log("Cleanup: window.paypal nullified/deleted.");
        } catch (e) {
          console.warn("Cleanup: Could not delete window.paypal:", e);
        }
      }
  
      // Clear the generic PayPal button container
      if (paypalContainerRef.current) {
        paypalContainerRef.current.innerHTML = '';
        console.log("Cleanup: Cleared generic PayPal button container.");
      }

      // Clear the specific subscription button container
      const subscriptionContainer = document.getElementById(PAYPAL_SUBSCRIPTION_CONTAINER_ID);
      if (subscriptionContainer) {
        subscriptionContainer.innerHTML = '';
        console.log("Cleanup: Cleared specific subscription PayPal button container.");
      }
  
      paypalRenderedRef.current = false;
      scriptLoadingRef.current = false;
      console.log("Cleanup: PayPal SDK cleanup complete. Render flags reset.");
      
    } catch (error) {
      console.error("Cleanup: An error occurred during PayPal SDK cleanup:", error);
    }
  }, []);
  

  useEffect(() => {
    try {
      $(".preloader").fadeOut();
    } catch (err) {
      console.warn("Failed to hide preloader:", err);
    }
  }, []);
  
  useEffect(() => {
    try {
      if (reduxStatus === "failed" && error) {
        errorMessage(error);
      }
    } catch (err) {
      console.error("Error handling Redux status failure:", err);
    }
  }, [error, reduxStatus]);
  

  useEffect(() => {
    const fetchMembershipTypes = async () => {
      setLoadingMembershipTypes(true);
      try {
        const response = await getallmembershiptypes();
        if (response?.status === 200 && response.data) {
          setMembershipTypes(
            Array.isArray(response.data)
              ? response.data.filter((type) => type.status === "1")
              : []
          );
        } else {
          errorMessage("Error fetching membership types!");
        }
      } catch (error) {
        console.error("Error fetching membership types:", error);
        errorMessage("Error fetching membership types!");
      } finally {
        setLoadingMembershipTypes(false);
      }
    };
    fetchMembershipTypes();
  }, []);

  //Effect to determine if membership expired more than 30 days ago
  // useEffect(() => {
  //   try {
  //     const currentValidUpto = localStorage.getItem('validupto');
  //     if (currentValidUpto) {
  //       const parts = currentValidUpto.split('-');
  //       if (parts.length === 3) {
  //         const validUptoDate = new Date(
  //           parseInt(parts[0]),
  //           parseInt(parts[1]) - 1,
  //           parseInt(parts[2])
  //         );
  //         const today = new Date();
  
  //         // Set both dates to midnight for accurate day comparison
  //         validUptoDate.setHours(0, 0, 0, 0);
  //         today.setHours(0, 0, 0, 0);
  
  //         const diffTime = today.getTime() - validUptoDate.getTime();
  //         const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  //         if (diffDays > 30) {
  //           setIsExpiredMoreThan30Days(true);
  //           setPaymentMode("onetime"); // Force one-time payment if expired > 30 days
  //         } else {
  //           setIsExpiredMoreThan30Days(false);
  //         }
  //       } else {
  //         console.warn("Invalid date format for 'validupto':", currentValidUpto);
  //         setIsExpiredMoreThan30Days(false);
  //       }
  //     } else {
  //       setIsExpiredMoreThan30Days(false);
  //     }
  //   } catch (error) {
  //     console.error("Error parsing 'validupto' from localStorage:", error);
  //     setIsExpiredMoreThan30Days(false);
  //   }
  // }, []);


  useEffect(() => {
    try {
      const currentValidUpto = localStorage.getItem('validupto');
      if (currentValidUpto) {
        const validUptoDate = new Date(currentValidUpto); // Parses YYYY-MM-DD format
  
        if (!isNaN(validUptoDate.getTime())) {
          // ✅ Add 1 month
          validUptoDate.setMonth(validUptoDate.getMonth() + 1);
  
          const today = new Date();
  
          validUptoDate.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
  
          const diffTime = today.getTime() - validUptoDate.getTime();
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
          if (diffDays > 32) {
            setIsExpiredMoreThan30Days(true);
            setPaymentMode("onetime");
          } else {
            setIsExpiredMoreThan30Days(false);
          }
        } else {
          console.warn("Invalid date value for 'validupto':", currentValidUpto);
          setIsExpiredMoreThan30Days(false);
        }
      } else {
        setIsExpiredMoreThan30Days(false);
      }
    } catch (error) {
      console.error("Error parsing 'validupto' from localStorage:", error);
      setIsExpiredMoreThan30Days(false);
    }
  }, []);
  
  
  
  const formik = useFormik({
    initialValues: {
      membershiptype: "",
      validUpto: "",
      amount: 0,
    },
    validationSchema: Yup.object({
      membershiptype: Yup.string().required("Membership type is required"),
    }),
    onSubmit: (values) => {
      console.log("Renew Membership Form Submitted", values);
  
      const selectedType = membershipTypes.find(
        (type) => type.id === values.membershiptype
      );
  
      if (!selectedType || parseFloat(selectedType.amount) <= 0) {
        errorMessage("Selected membership type has no valid amount.");
        return;
      }
  
      let finalAmount = parseFloat(selectedType.amount);
  
      if (isExpiredMoreThan30Days && paymentMode === "onetime") {
        const currentValidUpto = localStorage.getItem('validupto');
        if (currentValidUpto) {
          const parts = currentValidUpto.split('-');
          if (parts.length === 3) {
            const validUptoDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
            const today = new Date();
  
            const diffMonths =
              (today.getFullYear() - validUptoDate.getFullYear()) * 12 +
              (today.getMonth() - validUptoDate.getMonth());
  
            const durationInMonths = parseInt(selectedType.duration) / 30; // Assuming duration is in days
            const monthlyRate =
              durationInMonths > 0
                ? parseFloat(selectedType.amount) / durationInMonths
                : parseFloat(selectedType.amount);
  
            const monthsExpired = Math.max(0, diffMonths);
            finalAmount = monthsExpired * monthlyRate;
  
            setAdjustedOneTimeAmount(finalAmount);
            console.log(
              `Membership expired ${monthsExpired} months ago. Monthly rate: $${monthlyRate.toFixed(
                2
              )}. Adjusted one-time amount: $${finalAmount.toFixed(2)}`
            );
          } else {
            console.warn("Invalid 'validupto' format:", currentValidUpto);
          }
        }
      } else {
        setAdjustedOneTimeAmount(0);
      }
  
      setSelectedMembershipDetails({
        membershipTypeId: selectedType.id,
        membershipTypeName: selectedType.name,
        membershipTypeAmount: finalAmount, // This will be the adjusted amount for one-time, or base for subscription
        newValidUpto: values.validUpto,
        paypalPlanId: selectedType.paypal_plan_id,
      });
  
      setShowPaymentSection(true);
      setPaymentStatus(null);
    },
  });
  
  // const handleMembershipTypeChange = (e) => {
  //   const selectedMembershipId = e.target.value;
  //   const selectedType = membershipTypes.find(
  //     (type) => type.id === selectedMembershipId
  //   );
  
  //   formik.handleChange(e);
  
  //   if (selectedType) {
  //     const currentValidUpto = localStorage.getItem('validupto');
  //     let newValidityCalculationDate = new Date(); // Start calculation from today's date
  
  //     if (currentValidUpto) {
  //       const parts = currentValidUpto.split('-');
  //       if (parts.length === 3) {
  //         const storedValidUptoDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  //         const today = new Date();
  //         today.setHours(0, 0, 0, 0); // Normalize today for comparison
  
  //         if (storedValidUptoDate.getTime() > today.getTime()) {
  //           newValidityCalculationDate = storedValidUptoDate;
  //         }
  //       } else {
  //         console.warn("Invalid 'validupto' date format in localStorage. Using today's date for new validity calculation.");
  //       }
  //     } else {
  //       console.warn("'validupto' not found in localStorage. Using today's date for new validity calculation.");
  //     }
  
  //     const duration = parseInt(selectedType.duration);
  //     newValidityCalculationDate.setDate(newValidityCalculationDate.getDate() + duration);
  
  //     // Format the date to MM-DD-YYYY for display
  //     const formattedValidUpto = `${String(newValidityCalculationDate.getMonth() + 1).padStart(2, '0')}-${String(newValidityCalculationDate.getDate()).padStart(2, '0')}-${newValidityCalculationDate.getFullYear()}`;
  //     formik.setFieldValue("validUpto", formattedValidUpto);
  //     formik.setFieldValue("amount", parseFloat(selectedType.amount));
  //   } else {
  //     formik.setFieldValue("validUpto", "");
  //     formik.setFieldValue("amount", 0);
  //   }
  // };

  // This useEffect hook is responsible for loading and rendering PayPal buttons
 
 
  // const handleMembershipTypeChange = (e) => {
  //   const selectedMembershipId = e.target.value;
  //   const selectedType = membershipTypes.find(
  //     (type) => type.id === selectedMembershipId
  //   );
  
  //   formik.handleChange(e);
  
  //   if (selectedType) {
  //     let baseDateForAddingDuration; // This will be the date after the initial +1 month from localStorage
  //     const currentValidUpto = localStorage.getItem('validupto'); // NOW Expecting YYYY-MM-DD
  
  //     console.log("currentValidUpto", currentValidUpto);

  //     if (currentValidUpto) {
  //       const parts = currentValidUpto.split('-'); // YYYY-MM-DD
  //       if (parts.length === 3) {
  //         // ✅ CHANGE HERE: Parse year, month, day based on YYYY-MM-DD format
  //         const year = parseInt(parts[0], 10);
  //         const month = parseInt(parts[1], 10) - 1; // JS months are 0-based
  //         const day = parseInt(parts[2], 10);
  
  //         // 1. Construct UTC base date from localStorage value
  //         let initialDateFromLocalStorage = new Date(Date.UTC(year, month, day));
  //         console.log("1. Initial date from localStorage (UTC):", initialDateFromLocalStorage.toISOString());
  
  //         // 2. Add exactly one month to the initial date
  //         baseDateForAddingDuration = new Date(initialDateFromLocalStorage.getTime()); // Clone
  //         baseDateForAddingDuration.setUTCMonth(baseDateForAddingDuration.getUTCMonth() + 1);
  
  //         console.log("2. Base date after initial +1 month (UTC):", baseDateForAddingDuration.toISOString());
  
  //       } else {
  //         console.warn("Invalid 'validupto' format. Using today + 1 month as base.");
  //         const today = new Date();
  //         baseDateForAddingDuration = new Date(Date.UTC(
  //           today.getUTCFullYear(),
  //           today.getUTCMonth() + 1,
  //           today.getUTCDate()
  //         ));
  //       }
  //     } else {
  //       console.warn("'validupto' not found. Using today + 1 month as base.");
  //       const today = new Date();
  //       baseDateForAddingDuration = new Date(Date.UTC(
  //         today.getUTCFullYear(),
  //         today.getUTCMonth() + 1,
  //         today.getUTCDate()
  //       ));
  //     }
  
  //     const durationInDaysFromType = parseInt(selectedType.duration, 10);
  //     let monthsToAddFromType;
  
  //     // Conditional logic for 'duration'
  //     if (durationInDaysFromType === 30) {
  //         monthsToAddFromType = 0; // Special case: For duration 30, add 0 additional months
  //         console.log("DEBUG: Special rule applied: For duration 30, adding 0 additional months.");
  //     } else {
  //         monthsToAddFromType = durationInDaysFromType / 30; // General case: Calculate additional months
  //         console.log("DEBUG: General rule applied: Calculating months from duration / 30.");
  //     }
  
  //     console.log("DEBUG: selectedType.duration =", selectedType.duration);
  //     console.log("DEBUG: durationInDaysFromType (parsed) =", durationInDaysFromType);
  //     console.log("DEBUG: monthsToAddFromType (calculated for membership type) =", monthsToAddFromType);
  
  //     // Helper function to add months, handling day overflow (e.g., Jan 30 + 1 month = Feb 28)
  //     function addUTCMonthsSafely(date, months) {
  //         const d = new Date(date.getTime()); // Clone the date
  //         const originalDay = d.getUTCDate();
  //         d.setUTCMonth(d.getUTCMonth() + months); // Add months
  
  //         const lastDayOfTargetMonth = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
  //         if (originalDay > lastDayOfTargetMonth) {
  //             d.setUTCDate(lastDayOfTargetMonth);
  //         }
  //         return d;
  //     }
  
  //     // Apply the monthsToAddFromType using the safe helper
  //     let finalValidUptoDate = addUTCMonthsSafely(baseDateForAddingDuration, monthsToAddFromType);
  
  //     console.log("3. Final Valid Upto Date (UTC):", finalValidUptoDate.toISOString());
  
  //     // Format as MM-DD-YYYY using UTC values (output format remains the same)
  //     const year = finalValidUptoDate.getUTCFullYear();
  //     const month = String(finalValidUptoDate.getUTCMonth() + 1).padStart(2, '0');
  //     const day = String(finalValidUptoDate.getUTCDate()).padStart(2, '0');
  //     const formattedValidUpto = `${month}-${day}-${year}`;
  
  //     console.log("Formatted Valid Upto:", formattedValidUpto);
  
  //     formik.setFieldValue("validUpto", formattedValidUpto);
  //     formik.setFieldValue("amount", parseFloat(selectedType.amount));
  //   } else {
  //     formik.setFieldValue("validUpto", "");
  //     formik.setFieldValue("amount", 0);
  //   }
  // };


  const handleMembershipTypeChange = (e) => {
    const selectedMembershipId = e.target.value;
    const selectedType = membershipTypes.find(
      (type) => type.id === selectedMembershipId
    );
  
    formik.handleChange(e);
  
    if (selectedType) {
      let baseDateForAddingDuration; // This will be the date after the initial +1 month from localStorage
      const currentValidUpto = localStorage.getItem('validupto'); // NOW Expecting YYYY-MM-DD
  
      console.log("currentValidUpto", currentValidUpto);

      if (currentValidUpto) {
        const parts = currentValidUpto.split('-'); // YYYY-MM-DD
        if (parts.length === 3) {
          const year = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; // JS months are 0-based
          const day = parseInt(parts[2], 10);
  
          // 1. Construct UTC base date from localStorage value
          let initialDateFromLocalStorage = new Date(Date.UTC(year, month, day));
          console.log("1. Initial date from localStorage (UTC):", initialDateFromLocalStorage.toISOString());
  
          // 2. Add exactly one month to the initial date
          baseDateForAddingDuration = new Date(initialDateFromLocalStorage.getTime()); // Clone
          baseDateForAddingDuration.setUTCMonth(baseDateForAddingDuration.getUTCMonth() + 1);
  
          console.log("2. Base date after initial +1 month (UTC):", baseDateForAddingDuration.toISOString());
  
        } else {
          console.warn("Invalid 'validupto' format. Using today + 1 month as base.");
          const today = new Date();
          baseDateForAddingDuration = new Date(Date.UTC(
            today.getUTCFullYear(),
            today.getUTCMonth() + 1,
            today.getUTCDate()
          ));
        }
      } else {
        console.warn("'validupto' not found. Using today + 1 month as base.");
        const today = new Date();
        baseDateForAddingDuration = new Date(Date.UTC(
          today.getUTCFullYear(),
          today.getUTCMonth() + 1,
          today.getUTCDate()
        ));
      }
  
      const durationInDaysFromType = parseInt(selectedType.duration, 10);
      let monthsToAddFromType;
  
      // Conditional logic for 'duration'
      if (durationInDaysFromType === 30) {
          monthsToAddFromType = 0; // Special case: For duration 30, add 0 additional months
          console.log("DEBUG: Special rule applied: For duration 30, adding 0 additional months.");
      } else {
          monthsToAddFromType = (durationInDaysFromType / 30)-1; // General case: Calculate additional months
          console.log("DEBUG: General rule applied: Calculating months from duration / 30.");
      }
  
      console.log("DEBUG: selectedType.duration =", selectedType.duration);
      console.log("DEBUG: durationInDaysFromType (parsed) =", durationInDaysFromType);
      console.log("DEBUG: monthsToAddFromType (calculated for membership type) =", monthsToAddFromType);
  
      // Helper function to add months, handling day overflow (e.g., Jan 30 + 1 month = Feb 28)
      function addUTCMonthsSafely(date, months) {
          const d = new Date(date.getTime()); // Clone the date
          const originalDay = d.getUTCDate();
          d.setUTCMonth(d.getUTCMonth() + months); // Add months
  
          const lastDayOfTargetMonth = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
          if (originalDay > lastDayOfTargetMonth) {
              d.setUTCDate(lastDayOfTargetMonth);
          }
          return d;
      }
  
      // Apply the monthsToAddFromType using the safe helper
      let finalValidUptoDate = addUTCMonthsSafely(baseDateForAddingDuration, monthsToAddFromType);
  
      console.log("3. Final Valid Upto Date (UTC - before last day adjustment):", finalValidUptoDate.toISOString());
      
      // ✅ NEW LOGIC: Set the day to the last day of its current month
      finalValidUptoDate.setUTCDate(new Date(Date.UTC(finalValidUptoDate.getUTCFullYear(), finalValidUptoDate.getUTCMonth() + 1, 0)).getUTCDate());
      console.log("4. Final Valid Upto Date (UTC - after last day adjustment):", finalValidUptoDate.toISOString());

      // Format as MM-DD-YYYY using UTC values (output format remains the same)
      const year = finalValidUptoDate.getUTCFullYear();
      const month = String(finalValidUptoDate.getUTCMonth() + 1).padStart(2, '0');
      const day = String(finalValidUptoDate.getUTCDate()).padStart(2, '0');
      const formattedValidUpto = `${month}-${day}-${year}`;
  
      console.log("Formatted Valid Upto:", formattedValidUpto);
  
      formik.setFieldValue("validUpto", formattedValidUpto);
      formik.setFieldValue("amount", parseFloat(selectedType.amount));
    } else {
      formik.setFieldValue("validUpto", "");
      formik.setFieldValue("amount", 0);
    }
  };

  useEffect(() => {
    // Ensure essential details are available before proceeding
    if (!showPaymentSection || !selectedMembershipDetails || !userId) {
      console.log("Missing essential details, skipping PayPal initialization.");
      return;
    }

    const { membershipTypeId, membershipTypeName, membershipTypeAmount, newValidUpto, paypalPlanId } = selectedMembershipDetails;

    // Prevent re-rendering if PayPal buttons are already active or script is loading
    if (paypalRenderedRef.current || scriptLoadingRef.current) {
      console.log("PayPal buttons already rendered or script loading in progress, skipping re-initialization.");
      setLoadingPayPal(false);
      return;
    }

    scriptLoadingRef.current = true; // Set flag to indicate script loading has started

    const loadAndRenderPayPalButtons = async () => {
      setLoadingPayPal(true); // Indicate loading state
      try {
        cleanupPayPalSDK(); // Clean up any previous SDK instances
        // Introduce a small delay to allow browser to clear up resources
        await new Promise(resolve => setTimeout(resolve, 50)); // Wait for 50ms

        let containerToRender = null;
        if (paymentMode === "subscription") {
          // For subscription, target the specific div ID provided by PayPal
          containerToRender = document.getElementById(PAYPAL_SUBSCRIPTION_CONTAINER_ID);
          if (!containerToRender) {
            console.error("PayPal subscription button container not found in DOM. Cannot proceed.");
            errorMessage("Payment container for subscription not found. Please refresh the page.");
            setPaymentStatus('fail');
            setLoadingPayPal(false);
            scriptLoadingRef.current = false;
            return;
          }
        } else {
          // For one-time payment, use the ref provided to the component
          containerToRender = paypalContainerRef.current;
          if (!containerToRender) {
            console.error("PayPal one-time button container not found in DOM. Cannot proceed.");
            errorMessage("Payment container not found. Please refresh the page.");
            setPaymentStatus('fail');
            setLoadingPayPal(false);
            scriptLoadingRef.current = false;
            return;
          }
        }

        const scriptId = 'paypal-sdk-script';
        const existingScript = document.getElementById(scriptId);

        // Only append script if it doesn't exist
        if (!existingScript) {
          const script = document.createElement('script');
          script.id = scriptId;
          // Updated Client ID as per your provided snippet
         // const CLIENT_ID = "AdIC-dKALIhrIWWpcWxiuDFecByoYtS_rTHiTeugnaKvgjHll8JDVDbyRCutlaPYBtk2HeULvHKELome";
         const CLIENT_ID = "AdIC-dKALIhrIWWpcWxiuDFecByoYtS_rTHiTeugnaKvgjHll8JDVDbyRCutlaPYBtk2HeULvHKELome";

          if (paymentMode === "subscription") {
            script.src = `https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&vault=true&intent=subscription`;
          } else {
            script.src = `https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}&currency=USD`;
          }

          script.setAttribute('data-sdk-integration-source', 'button-factory');
          script.async = true;
          document.body.appendChild(script);
          console.log("PayPal SDK script appended to body.");

          // Wait for the script to load and window.paypal to be ready
          await new Promise((resolve, reject) => {
            script.onload = () => {
              console.log("PayPal SDK script loaded. Starting check for window.paypal.Buttons...");
              const checkReady = setInterval(() => {
                if (window.paypal && typeof window.paypal.Buttons === 'function') {
                  clearInterval(checkReady);
                  console.log("PayPal SDK loaded and ready (Buttons function found).");
                  resolve();
                }
              }, 100); // Check every 100ms
            };
            script.onerror = (error) => {
              console.error("Failed to load PayPal SDK script:", error);
              reject(new Error("PayPal SDK script failed to load."));
            };
          });
        } else {
          console.log("PayPal SDK script already exists, proceeding to render buttons.");
          // If script already exists, ensure window.paypal is ready
          await new Promise((resolve, reject) => {
            const checkReady = setInterval(() => {
              if (window.paypal && typeof window.paypal.Buttons === 'function') {
                clearInterval(checkReady);
                console.log("PayPal SDK already loaded and ready (Buttons function found).");
                resolve();
              }
            }, 100);
          });
        }

        console.log("Attempting to render PayPal buttons...");

        if (paymentMode === "subscription") {
          window.paypal.Buttons({
            style: {
              shape: 'pill',
              color: 'gold',
              layout: 'vertical',
              label: 'subscribe',
            },
            createSubscription: function (data, actions) {
              // Ensure paypalPlanId is available from selectedMembershipDetails
              if (!paypalPlanId) {
                errorMessage("PayPal Plan ID is missing for this membership type.");
                throw new Error("PayPal Plan ID missing.");
              }
              console.log("Creating subscription with plan_id:", paypalPlanId);
              return actions.subscription.create({
                plan_id: paypalPlanId, // Use the dynamic paypalPlanId
              });
            },
            onApprove: async function (data, actions) {
              if (data.subscriptionID) {
                setSubscriptionID(data.subscriptionID);
                setPaymentStatus('success');
                successMessage("Payment successful! Updating membership status...");
                console.log("PayPal subscription approved. ID:", data.subscriptionID);

                try {
                  // Dispatch action to save payment record
                  await (savemembershippayment({
                    member: userId,
                    orderid: data.subscriptionID,
                    paymentstatus: 'COMPLETED',
                    amount: membershipTypeAmount,
                    paymentmode: 'Paypal Subscription',
                    //date: new Date().toISOString().split('T')[0], // YYYY-MM-DD format
                    date:new Date().toLocaleDateString('en-CA'),
                    subscription: membershipTypeId,
                    status: 1
                  }));
                  console.log("Payment record saved successfully in backend.");

                  // Dispatch action to update member's valid_upto date

                  const parts = newValidUpto.split('-'); // e.g., ["01", "31", "2026"]
                  const validUptoForBackend = `${parts[2]}-${parts[0]}-${parts[1]}`; // Result: "2026-01-31"


                  await (editMember({
                    id: userId,
                    validupto: validUptoForBackend,
                    status: "1"
                  }));
                  localStorage.setItem('validupto', validUptoForBackend);
                  console.log("Member validupto updated successfully after payment.");
                  successMessage("Membership successfully renewed!");
                  startCountdownAndRedirect();
                } catch (backendError) {
                  console.error("Error during backend update after PayPal approval:", backendError);
                  errorMessage("Payment successful, but failed to update your membership or save payment record in backend. Please contact support.");
                  setPaymentStatus('fail');
                }
              } else {
                setPaymentStatus('fail');
                errorMessage("PayPal subscription ID not returned.");
                console.error("PayPal subscription ID missing from onApprove data.");
              }
            },
            onCancel: function () {
              setPaymentStatus('cancel');
              errorMessage("PayPal subscription cancelled by user.");
              console.log("PayPal subscription cancelled.");
            },
            onError: function (err) {
              console.error('PayPal Error (Subscription):', err);
              setPaymentStatus('fail');
              errorMessage("An error occurred during PayPal subscription. Please try again.");
            }
          }).render(containerToRender); // Use the specific container for subscriptions
        } else {
          window.paypal.Buttons({
            style: {
              shape: 'pill',
              color: 'blue',
              layout: 'vertical',
              label: 'pay',
            },
            createOrder: function (data, actions) {
              return actions.order.create({
                purchase_units: [{
                  amount: {
                    value: membershipTypeAmount.toFixed(2),
                    currency_code: "USD"
                  },
                  description: `One-time Membership Payment: ${membershipTypeName}`,
                }]
              });
            },
            onApprove: async function (data, actions) {
              try {
                const order = await actions.order.capture();
                console.log("One-time payment order captured", order);
                setSubscriptionID(order.id);
                setPaymentStatus('success');
                successMessage("Payment successful! Updating membership status...");

                try {
                  await (savemembershippayment({
                    member: userId,
                    orderid: order.id,
                    paymentstatus: 'COMPLETED',
                    amount: membershipTypeAmount,
                    paymentmode: 'Paypal One-Time',
                    subscription: membershipTypeId,
                    //date: new Date().toISOString().split('T')[0],
                    date:new Date().toLocaleDateString('en-CA') ,
                    status: 1
                  }));
                  console.log("Payment record saved successfully in backend.");

                  // await (editMember({
                  //   id: userId,
                  //   validupto: newValidUpto,
                  //   status: "1"
                  // }));

                  const parts = newValidUpto.split('-'); // e.g., ["01", "31", "2026"]
                  const validUptoForBackend = `${parts[2]}-${parts[0]}-${parts[1]}`; // Result: "2026-01-31"


                  await (editMember({
                    id: userId,
                    validupto: validUptoForBackend,
                    status: "1"
                  }));

                  localStorage.setItem('validupto', newValidUpto);
                  console.log("Member validupto updated successfully after payment.");
                  successMessage("Membership successfully renewed!");
                  startCountdownAndRedirect();
                } catch (backendError) {
                  console.error("Error during backend update after PayPal approval:", backendError);
                  errorMessage("Payment successful, but failed to update your membership or save payment record in backend. Please contact support.");
                  setPaymentStatus('fail');
                }
              } catch (captureError) {
                console.error("PayPal Capture Error (One-Time):", captureError);
                setPaymentStatus('fail');
                errorMessage("Failed to capture PayPal payment. Please try again.");
              }
            },
            onCancel: function (data) {
              setPaymentStatus('cancel');
              errorMessage("PayPal payment cancelled by user.");
              console.log("PayPal one-time payment cancelled.", data);
            },
            onError: function (err) {
              console.error('PayPal Error (One-Time):', err);
              setPaymentStatus('fail');
              errorMessage("An error occurred during PayPal payment. Please try again.");
            }
          }).render(containerToRender); // Use the ref for one-time payments
        }

        console.log("PayPal buttons rendered successfully.");
        paypalRenderedRef.current = true; // Set flag to indicate buttons are rendered
      } catch (e) {
        console.error("Error during PayPal button initialization:", e);
        setPaymentStatus('fail');
        errorMessage("Failed to load PayPal payment options.");
      } finally {
        setLoadingPayPal(false); // End loading state
        scriptLoadingRef.current = false; // Reset script loading flag
      }
    };

    loadAndRenderPayPalButtons();

    // Cleanup function when component unmounts or dependencies change
    return () => {
      console.log("Running cleanup via useEffect return function.");
      cleanupPayPalSDK();
    };
  }, [
    showPaymentSection,
    selectedMembershipDetails,
    userId,
    dispatch,
    unwrapResult,
    startCountdownAndRedirect,
    cleanupPayPalSDK,
    paymentMode,
    isExpiredMoreThan30Days // Added as a dependency as it influences paymentMode
  ]);

  return (
    <div>
      <Navbar />
      {!hidesidebar && <Sidebar />}
      {(loadingMembershipTypes || (showPaymentSection && loadingPayPal)) && (
        <div className="preloader" style={{ display: "block" }}>
          <div className="lds-ripple">
            <div className="lds-pos"></div>
            <div className="lds-pos"></div>
          </div>
        </div>
      )}

      <div id="main-wrapper" className="flex flex-col min-h-screen">
        <div className="page-wrapper flex-grow d-block">
          <div className="body-wrapper">
            <Container fluid className="h-full">
              <div className="folio-container"></div>
              <Row className="justify-content-center items-center h-full min-h-[calc(100vh-60px)]">
                <Col lg={6} md={8}>
                  <Card className="w-100 rounded-xl shadow-lg">
                    <Card.Header style={{ background: "#f06969" }} className="rounded-t-xl">
                      <div className="d-sm-flex d-block align-items-center justify-content-between mb-4">
                        <h4 className="card-title fw-semibold text-white text-2xl">
                          {showPaymentSection ? "Membership Payment" : "Renew Membership"}
                        </h4>
                      </div>
                    </Card.Header>
                    <Card.Body className="p-6">
                      {!showPaymentSection ? (
                        <Form onSubmit={formik.handleSubmit}>
                          <Row>
                            <Col md={12}>
                              <Form.Group className="mb-3" controlId="membershiptype">
                                <Form.Label>Select New Membership Type</Form.Label>
                                <Form.Select
                                  {...formik.getFieldProps("membershiptype")}
                                  onChange={handleMembershipTypeChange}
                                  isInvalid={formik.touched.membershiptype && !!formik.errors.membershiptype}
                                >
                                  <option value="">Select Membership Type</option>
                                  {membershipTypes.map((type) => (
                                    <option key={type.id} value={type.id}>
                                      {type.name} - {type.duration} days - ${type.amount}
                                    </option>
                                  ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                  {formik.errors.membershiptype}
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>

                            <Form.Group className="mb-3">
                              <Form.Label>Select Payment Mode</Form.Label>
                              <div>
                                {/* Conditionally render subscription option */}
                                {(!isExpiredMoreThan30Days) && (formik.values.membershiptype === "2") && (
                                  <Form.Check
                                    inline
                                    label="Subscription"
                                    name="paymentMode"
                                    type="radio"
                                    id="subscription"
                                    checked={paymentMode === "subscription"}
                                    onChange={() => {
                                      setPaymentMode("subscription");
                                      paypalRenderedRef.current = false;
                                      scriptLoadingRef.current = false;
                                    }}
                                  />
                                )}
                                <Form.Check
                                  inline
                                  label="One-Time"
                                  name="paymentMode"
                                  type="radio"
                                  id="one-time"
                                  checked={paymentMode === "onetime"}
                                  onChange={() => {
                                    setPaymentMode("onetime");
                                    paypalRenderedRef.current = false;
                                    scriptLoadingRef.current = false;
                                  }}
                                  disabled={isExpiredMoreThan30Days} // Disable if subscription is forced
                                />
                              </div>
                               {isExpiredMoreThan30Days && (
                                <p className="text-sm text-red-500 mt-2">
                                  Your membership expired more than 30 days ago. Only one-time payment is available.
                                </p>
                              )}
                            </Form.Group>

                            {formik.values.validUpto && (
                              <Col md={12}>
                                <Form.Group className="mb-3" controlId="validUpto">
                                  <Form.Label>New Membership Valid Until</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={formik.values.validUpto}
                                    readOnly
                                  />
                                </Form.Group>
                              </Col>
                            )}
                          </Row>

                          <div className="text-center mt-3">
                            <Button variant="dark" type="submit" className="w-50" >
                              Proceed to Payment
                            </Button>
                          </div>
                        </Form>
                      ) : (
                        <div className="flex flex-col items-center justify-center bg-gray-100 p-4 rounded-b-xl font-inter">
                          <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md text-center">
                            <h2 className="text-3xl font-bold text-gray-800 mb-6">
                              Complete Your {paymentMode === "subscription" ? "Subscription" : "Payment"}</h2>
                            <p className="text-lg text-gray-600 mb-4">
                              Selected Membership: <strong>{selectedMembershipDetails?.membershipTypeName || 'N/A'}</strong> (Valid until: <strong>{selectedMembershipDetails?.newValidUpto || 'N/A'}</strong>)
                              <br />Amount: <strong>${selectedMembershipDetails?.membershipTypeAmount ? parseFloat(selectedMembershipDetails.membershipTypeAmount).toFixed(2) : '0.00'}</strong>
                              {isExpiredMoreThan30Days && paymentMode === "onetime" && (
                                <span className="block text-sm text-gray-500 mt-1"> (Adjusted for past due period)</span>
                              )}
                            </p>

                            {loadingPayPal && (
                              <div className="text-blue-600 text-lg mb-4">Loading PayPal buttons...</div>
                            )}

                            {/* Container for one-time payment buttons */}
                            <div id="paypal-button-container" ref={paypalContainerRef}
                                 style={{ display: paymentMode === 'onetime' ? 'block' : 'none' }}
                                 className="mb-6"></div>

                            {/* Specific container for subscription button */}
                            <div id={PAYPAL_SUBSCRIPTION_CONTAINER_ID}
                                 style={{ display: paymentMode === 'subscription' ? 'block' : 'none' }}
                                 className="mb-6"></div>


                            {paymentStatus === 'success' && (
                              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-md relative mb-4">
                                <strong className="font-bold">✅ Payment Successful!</strong>
                                <span className="block sm:inline"> Your membership is now active.</span>
                                {subscriptionID && (
                                  <p className="text-sm mt-2">Transaction ID: <code className="font-mono bg-green-200 p-1 rounded">{subscriptionID}</code></p>
                                )}
                                <p className="mt-3">Redirecting to dashboard in {countdown} seconds...</p>
                              </div>
                            )}

                            {paymentStatus === 'fail' && (
                              <div className="bg-red-100 text-red-700 p-4 rounded-lg font-semibold flex items-center justify-center gap-2">
                                <span className="text-2xl">❌</span> Payment Failed. Please try again or contact support.
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RenewMembershipAndPayment;
